<template>
  <div class="password-reset-complete-page">
    <sub-header-section :pageTitle="$tc('PasswordResetPage.subTitle')" />

    <password-reset-complete-pane class="password-reset-complete-page__content" />

    <action-buttons-section
      scrollTargetSelector=".password-reset-complete-page__content"
      :visible="true"
    >
      <atom-link-button
        :linkText="$tc('PasswordResetPage.CompletePage.backBtnText')"
        :url="loginUrl"
        :isOpenAsBlank="false"
        colorType="secondary"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomLinkButton from '@/components/atoms/AtomLinkButton.vue'
import PasswordResetCompletePane from '@/components/PasswordResetPage/PasswordResetCompletePane.vue'

/**
 * パスワードリセット完了 ページ
 */
export default defineComponent({
  name: 'PasswordResetCompletePage',
  components: {
    SubHeaderSection,
    ActionButtonsSection,
    AtomLinkButton,
    PasswordResetCompletePane,
  },
  setup() {
    const loginUrl = `${process.env.VUE_APP_BROWSER_CAN_REDIRECT_TO_APP_BASE_URL}#/login`

    return {
      loginUrl,
    }
  },
})
</script>

<style lang="scss">
.password-reset-complete-page {
  .action-buttons-section {
    bottom: 0;

    &__inner {
      padding-bottom: calc(16px + #{var(--safe-area-inset-bottom)});
    }
  }
}
</style>
